import scheduler from "@homer.core/scheduler";
import whenImages from "@homer.core/when.images";
import application from "@homer.core/application";
import page from "@homer.core/page";
import Script from "@homer.core/script";

scheduler.yield.low(whenImages).then(() => {
    const node = document.head.querySelector(':scope > meta[itemprop="rumdash"]');
    const key = node ? node.getAttribute("content") : null;

    if (!node || !key) {
        return;
    }

    const ready = new Promise((resolve, reject) => {
        globalThis.__rdOnLoad = () => {
            const rumdash = globalThis.RumDash;

            if (rumdash) {
                // RumDash starts collecting metrics immediately after this callback returns.
                rumdash.init({
                    key,
                    env: application.environment === "production" ? "prod" : "dev",
                    revision: application.version || undefined,
                    pageType: page.type,
                });

                page.on("change", () => {
                    rumdash.updatePageType(page.type);
                });

                resolve(rumdash);
            } else {
                reject(new Error(`globalThis.RumDash is ${rumdash}`));
            }
        };
    });

    new Script("/proxy/rumdash", {
        id: "rumdash",
        resolver: (resolve, reject) => {
            ready.then(resolve, reject);
        },
    }).finally(() => {
        delete globalThis.__rdOnLoad;
    });
});
